import React, {useReducer} from 'react';
import {connect} from "react-redux";
import QuotesSwitcher from "./quotesSwitcher/quotesSwitcher";
import ModeDropdown from "./ModeDropdown";
import {isSFTCabinetsGroup} from "../../helpers/sqftNavigationHelper";
import GroupDropdown from "./GroupDropdown";
import {getCurrentLayout} from "../../../appLayout";
import {SQFT_FEATURES} from "../../constants";
import {getNavItems} from "../../helpers/sqftHelperUi";
import AllFeaturesChecker from "../../../visComponents/allFeaturesChecker";

const SqftHeader = (props) => {
  const {roomSwitcher, isMobile} = props
  const isCabinetsMode = isSFTCabinetsGroup();
  const layout = getCurrentLayout();
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  const isQuotesSwitcherVisible = roomSwitcher.isVisible && !isMobile;
  const isModeDropDownVisible = isCabinetsMode;

  const bottomCabinetsFeatureGroup = layout.getFeatureGroupByPartId(SQFT_FEATURES.bottom_cabinet);
  const navItems = getNavItems(bottomCabinetsFeatureGroup, '', {}, true, true);
  const isGroupDownVisible = false; void navItems && navItems.length;

  const isHeaderBarVisible = isGroupDownVisible || isQuotesSwitcherVisible || isModeDropDownVisible;

  return (
    bottomCabinetsFeatureGroup && !bottomCabinetsFeatureGroup.allFeaturesReceived
      ? <div className="fullPageLoader">
          <AllFeaturesChecker subPart={{part: bottomCabinetsFeatureGroup}} callBack={() => forceUpdate(1)} loaderOnly={true}/>
        </div>
      : <div className={(isHeaderBarVisible ? "header-bar" : "")}>
        {isQuotesSwitcherVisible ? <QuotesSwitcher type={1}/> : null}
        {/*<QuotesSwitcher type={1}/>*/}
        {isModeDropDownVisible ? <ModeDropdown/> : null}
        {isGroupDownVisible ? <GroupDropdown/> : null}
      </div>
  )
};

const mapStateToProps = (store) => ({
  roomSwitcher: store.sqftMenuState.roomSwitcher,
  isMobile: store.serverState.isMobile,
  SQFTGroup: store.sqftState.SQFTGroup,
});

const mapDispatchToProps = {
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftHeader);
